import { AnyAction } from "redux"

export const CLEAR = "CLEAR"

export interface Clear extends AnyAction {
  resolved: typeof CLEAR
}
